import { render, staticRenderFns } from "./IssueCycleTableCell.vue?vue&type=template&id=1595bb45&scoped=true"
import script from "./IssueCycleTableCell.vue?vue&type=script&lang=js"
export * from "./IssueCycleTableCell.vue?vue&type=script&lang=js"
import style0 from "./IssueCycleTableCell.vue?vue&type=style&index=0&id=1595bb45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595bb45",
  null
  
)

export default component.exports